<template>
  <div class="app-container">
    <transition name="el-zoom-in-top">
      <div v-show="!showAdd&&!showMember&&!showStaff&&!showDetail" class="filter-container">
        <el-card class="custom-card" shadow="never">
          场地名称
          <el-input
            :placeholder="$t('table.fieldName')"
            v-model="listQuery.name"
            style="width: 200px;"
            class="filter-item"
            @keyup.enter.native="handleFilter"
          />
          <el-input
            :placeholder="`场地地址`"
            v-model="listQuery.address"
            style="width: 200px;"
            class="filter-item"
            @keyup.enter.native="handleFilter"
          />
          <el-select v-model="listQuery.state" class="filter-item" placeholder="请选择">
            <el-option
              v-for="item in stateSelect"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
          <!-- <el-select v-model="listQuery.roleId" :placeholder="$t('table.role')" clearable class="filter-item" style="width: 130px">
          <el-option v-for="item in roleList" :key="item.RoleId" :label="item.RoleName" :value="item.RoleId"/>
        </el-select>-->
          <el-button
            v-waves
            round
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
          >{{ $t('table.search') }}</el-button>
          <el-button
            v-if="calcPermission(permition, 1)"
            round
            class="filter-item"
            type="danger"
            icon="el-icon-circle-plus-outline"
            @click="addField"
          >{{ $t('table.add') }}</el-button>
          <el-button
            v-if="calcPermission(permition, 5)"
            round
            class="filter-item"
            type="primary"
            @click="bindAgent"
          >{{ $t('table.bindAgent') }}</el-button>
        </el-card>
      </div>

    </transition>
    <transition name="el-zoom-in-top">
      <div v-show="!showAdd&&!showMember&&!showStaff&&!showDetail" class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="list.id"
          :data="list"

          fit
          stripe
          highlight-current-row
          style="width: 100%;"
        >
          <el-table-column :label="$t('table.id')" fixed="left" align="center" width="100px">
            <template slot-scope="scope">
              <span>{{ (scope.$index + 1) + ((listQuery.pageIndex - 1) * listQuery.pageSize) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.fieldName')" fixed="left" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.FieldInfo.FieldName }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.fieldAddress ')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.FieldInfo.Address">{{ scope.row.FieldInfo.Address }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`管理员`" align="center">
            <template slot-scope="scope">
              <template
                v-if="scope.row.FieldInfo.UserId ||
                  scope.row.FieldInfo.UserId1 ||
                  scope.row.FieldInfo.UserId2 ||
                  scope.row.FieldInfo.UserId3 ||
                  scope.row.FieldInfo.UserId4
                ">
                <el-link :underline="false" type="primary">{{
                  scope.row.UserName ||
                    scope.row.UserName1 ||
                    scope.row.UserName2 ||
                    scope.row.UserName3 ||
                    scope.row.UserName4
                }}</el-link>
                <!-- <el-tooltip placement="top">
                  <div slot="content">
                    <p>场地管理员1：{{ scope.row.UserName }}</p>
                  </div>

                </el-tooltip> -->
              </template>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`维护人员`" align="center">
            <template slot-scope="scope">
              <template v-if="scope.row.FieldInfo.DefendId || scope.row.FieldInfo.DefendId1 || scope.row.FieldInfo.DefendId2 || scope.row.FieldInfo.DefendId3 || scope.row.FieldInfo.DefendId4">
                <el-link :underline="false" type="primary">{{
                  scope.row.DefendName ||
                    scope.row.DefendName1 ||
                    scope.row.DefendName2 ||
                    scope.row.DefendName3 ||
                    scope.row.DefendName4
                }}</el-link>
                <!-- <el-tooltip placement="top">
                  <div slot="content">
                    <p>维护人员1：{{ scope.row.DefendName }}</p>
                  </div>

                </el-tooltip> -->
              </template>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column :label="`收费模式`" align="center">
            <template slot-scope="scope">
              <!-- <el-tooltip v-if="scope.row.FieldInfo.ChargingMode === 'DurationStage'" placement="top">
                <div v-if="scope.row.FieldInfo.StagePriceJson" slot="content">
                  <div v-for="(item, index) in scope.row.FieldInfo.StagePriceJson" :key="index">
                    时间（分钟）：{{ item.S }} - {{ item.E }}
                    价格：{{ item.P }}
                  </div>
                </div>
                <el-link
                  v-if="scope.row.FieldInfo.ChargingMode"
                  type="primary"
                >
                  {{ scope.row.FieldInfo.ChargingMode | fileterChangedDuration }}
                </el-link>
                <span v-else>--</span>
              </el-tooltip> -->
              <template v-if="scope.row.FieldInfo.ChargingMode === 'DurationStage'">
                <el-link :underline="false" type="primary">区间时长</el-link>
              </template>
              <span v-else>
                <span
                  v-if="scope.row.FieldInfo.ChargingMode"
                >
                  {{ scope.row.FieldInfo.ChargingMode | fileterChangedDuration }}
                </span>
                <span v-else>--</span>
              </span>

            </template>
          </el-table-column>
          <el-table-column :label="`滞留最大时长(h)`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.FieldInfo.Detention">{{ scope.row.FieldInfo.Detention }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column :label="`押金(元)`" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.FieldInfo.Deposit }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="`自动清理`" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.FieldInfo.IsAutoClear === 'Y' ? '是':'否' }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="`清理时间(H)`" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.FieldInfo.AutoClearTime }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="`时长模式`" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.FieldInfo.DurationType"
              >{{ scope.row.FieldInfo.DurationType | fileterDurationMode }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`时长(小时)`" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.FieldInfo.Hour"
              >{{ scope.row.FieldInfo.Hour }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column :label="`前X小时箱子价格(元)`" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.FieldInfo.SmallPrice01 }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="`箱子价格(元)`" width="300" align="center">
            <template slot-scope="scope">
              <template v-if="scope.row.FieldInfo.ChargingMode === 'DurationStage'">
                <div v-for="(item, index) in scope.row.FieldInfo.SmallStagePriceJson" :key="index">
                  时间（分钟）：{{ item.S }} - {{ item.E }}
                  价格：{{ item.P }}
                </div>
              </template>
              <template v-else>
                <span v-if="scope.row.FieldInfo.SmallPrice">{{ scope.row.FieldInfo.SmallPrice }}</span>
                <span v-else>0</span>
              </template>
            </template>
          </el-table-column>

          <el-table-column :label="`箱子封顶价格(元)`" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.FieldInfo.SmallCappingPrice"
              >{{ scope.row.FieldInfo.SmallCappingPrice }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>

          <el-table-column :label="`代理分成`" align="center">
            <template slot-scope="scope">
              <template v-if="scope.row.FieldInfo.AgentProportion || scope.row.FieldInfo.AgentProportion1 || scope.row.FieldInfo.AgentProportion2 || scope.row.FieldInfo.AgentProportion3 || scope.row.FieldInfo.AgentProportion4">
                <el-link :underline="false" type="primary">{{
                  scope.row.FieldInfo.AgentProportion ||
                    scope.row.FieldInfo.AgentProportion1 ||
                    scope.row.FieldInfo.AgentProportion2 ||
                    scope.row.FieldInfo.AgentProportion3 ||
                    scope.row.FieldInfo.AgentProportion4
                }}</el-link>
                <!-- <el-tooltip placement="top">
                  <div slot="content">
                    <p>代理比例1：{{ scope.row.FieldInfo.AgentProportion }}</p>
                  </div>

                </el-tooltip> -->
              </template>

              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column :label="`场地方分成`" align="center">
            <template slot-scope="scope">
              <template v-if="scope.row.FieldInfo.FieldProportion || scope.row.FieldInfo.FieldProportion1 || scope.row.FieldInfo.FieldProportion2 || scope.row.FieldInfo.FieldProportion3 || scope.row.FieldInfo.FieldProportion4">
                <el-link :underline="false" type="primary">{{
                  scope.row.FieldInfo.FieldProportion ||
                    scope.row.FieldInfo.FieldProportion1 ||
                    scope.row.FieldInfo.FieldProportion2 ||
                    scope.row.FieldInfo.FieldProportion3 ||
                    scope.row.FieldInfo.FieldProportion4
                }}</el-link>
                <!-- <el-tooltip placement="top">
                  <div slot="content">
                    <p>代理比例1：{{ scope.row.FieldInfo.FieldProportion }}</p>
                  </div>

                </el-tooltip> -->
              </template>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column v-if="RoleId === 1" :label="`总收入(元)`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.FieldInfo.TotalIncome">{{ scope.row.FieldInfo.TotalIncome }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column :label="`退款费用(元)`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.FieldInfo.RetCoinMoney">{{ scope.row.FieldInfo.RetCoinMoney }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column :label="`添加时间`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.FieldInfo.AddTime">{{ scope.row.FieldInfo.AddTime }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.UpdateTime')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.FieldInfo.UpdateTime || scope.row.FieldInfo.AddTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('table.actions')"
            fixed="right"
            align="center"
            width="200"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <el-link
                v-if="calcPermission(permition, 7) && scope.row.FieldInfo.StatusNo === 'A'"
                class="custom-link"
                type="danger"
                @click="stateChange(scope.row, 'S')"
              >禁用</el-link>
              <el-link
                v-if="calcPermission(permition, 7) && scope.row.FieldInfo.StatusNo === 'S'"
                class="custom-link"
                type="success"
                @click="stateChange(scope.row, 'A')"
              >启用</el-link>
              <el-link
                v-if="calcPermission(permition, 2)"
                class="custom-link"
                type="primary"
                @click="editField(scope.row)"
              >{{ $t('table.edit') }}</el-link>
              <el-link
                v-if="calcPermission(permition, 7)"
                class="custom-link"
                type="primary"
                @click="handleDetail(scope.row)"
              >详情</el-link>
              <!-- <el-dropdown v-if="calcPermission(permition, 3)">
                <span class="el-dropdown-link">
                  <el-link class="custom-link" type="primary">
                    <i class="el-icon-more"/>
                  </el-link>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <el-link
                      v-if="calcPermission(permition, 3)"
                      @click="member(scope.row)"
                    >查询会员</el-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-link
                      v-if="calcPermission(permition, 4)"
                      @click="staff(scope.row)"
                    >查询员工</el-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-link
                      v-if="calcPermission(permition, 5)"
                      @click="handleBind(scope.row)"
                    >添加员工</el-link>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </template>
          </el-table-column>
        </el-table>
        <el-card class="custom-card" shadow="never">
          <el-pagination
            v-show="total>0"
            :current-page="listQuery.pageIndex"
            :page-sizes="[10,20,50,100]"
            :page-size="listQuery.pageSize"
            :total="total"
            layout="total, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
        <!-- 弹出二维码 -->
        <el-dialog
          :visible.sync="dialogVisible"
          :before-close="handleClose"
          title="请使用微信扫描下方二维码绑定员工"
          width="30%"
        >
          <div id="qrcode" ref="qrcode"/>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
          </span>
        </el-dialog>
      </div>
    </transition>
    <!-- 编辑/新增 -->
    <transition name="el-zoom-in-bottom">
      <add-field v-if="showAdd" :detail="detail" :status="status" @backList="backList"/>
    </transition>
    <transition name="el-zoom-in-bottom">
      <member-list v-if="showMember" :id="id" @back="back"/>
    </transition>
    <transition name="el-zoom-in-bottom">
      <staff-list v-if="showStaff" :id="id" @back="back"/>
    </transition>
    <transition name="el-zoom-in-bottom">
      <field-detail v-if="showDetail" :fieldItem="fieldItem" @back="back"/>
    </transition>
  </div>
</template>
<script>
import { qryFieldInfo, updateFieldState, clearFieldUserIncrease } from '@/api/field'
import { qryRoleInfo } from '@/api/baseModule'
import addField from './addField'
import memberList from './memberList'
import staffList from './staffList'
import fieldDetail from './fieldDetail'
import QrCode from 'qrcodejs2'
import waves from '@/directive/waves' // 水波纹指令
export default {
  name: 'UserManage',
  directives: {
    waves
  },
  components: {
    addField,
    memberList,
    staffList,
    fieldDetail
  },
  filters: {
    fileterChangedDuration(value) {
      let str = ''
      switch (value) {
        case 'Duration':
          str = '时长'
          break
        case 'Frequency':
          str = '次数'
          break
        case 'Month':
          str = '包月'
          break
        case 'DurationStage':
          str = '区间时长'
          break
        case 'Free':
          str = '免费'
          break
      }
      return str
    },
    fileterDurationMode(value) {
      let str = ''
      switch (value) {
        case 'two':
          str = '前X小时Y元后续一小时Z元'
          break
        case 'one':
          str = 'X小时Y元'
          break
      }
      return str
    }
  },
  data() {
    return {
      showAdd: false,
      showMember: false,
      showStaff: false,
      showDetail: false,
      fieldItem: false,
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        name: null,
        address: null,
        state: 'A'
      },
      stateSelect: [
        {
          value: 'A',
          label: '启用'
        },
        {
          value: 'S',
          label: '禁用'
        }
      ],
      listLoading: true,
      list: [],
      permition: 0,
      total: null,
      detail: null,
      id: null,
      userInfo: null,
      RoleId: null,
      status: null,
      dialogVisible: false,
      qr: null
    }
  },
  created() {
    this.RoleId = this.$store.getters.roles.RoleId
    console.log(this.RoleId, 383)
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          this.qryField()
        }
      })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            this.qryField()
          }
        })
      })
    }
  },
  methods: {
    // 清理场地用户增长量
    handleClearFieldUserIncrease(fieldId) {
      clearFieldUserIncrease({ fieldId }).then(res => {
        if (res) {
          this.$message.success('清理成功')
          this.qryField()
        }
      })
    },
    // 获取场地列表
    qryField() {
      this.listQuery.name = this.listQuery.name || null
      this.listQuery.address = this.listQuery.address || null
      qryFieldInfo(this.listQuery).then(request => {
        request.LsList.forEach(item => {
          if (item.FieldInfo.SmallStagePriceJson) {
            item.FieldInfo.SmallStagePriceJson = JSON.parse(item.FieldInfo.SmallStagePriceJson)
          }
          if (item.FieldInfo.MidStagePriceJson) {
            item.FieldInfo.MidStagePriceJson = JSON.parse(item.FieldInfo.MidStagePriceJson)
          }
          if (item.FieldInfo.BigStagePriceJson) {
            item.FieldInfo.BigStagePriceJson = JSON.parse(item.FieldInfo.BigStagePriceJson)
          }
          if (item.FieldInfo.SuperBigStagePriceJson) {
            item.FieldInfo.SuperBigStagePriceJson = JSON.parse(item.FieldInfo.SuperBigStagePriceJson)
          }
        })
        this.list = request.LsList
        this.total = request.TotalRows
        this.listLoading = false
      })
    },
    // 禁用/启用
    stateChange(row, value) {
      updateFieldState({
        fieldId: row.FieldInfo.FieldId,
        state: value
      }).then(res => {
        if (res) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.qryField()
        }
      })
    },
    // 场地详情
    handleDetail(item) {
      console.log(item)
      this.fieldItem = item
      this.showDetail = true
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e
      this.qryField()
    },
    handleCurrentChange(e) {
      this.listQuery.pageIndex = e
      this.qryField()
    },
    handleFilter() {
      this.listLoading = true
      this.qryField()
    },
    addField() {
      this.status = true
      this.detail = {
        FieldInfo: {
          FieldName: null,
          Longitude: null,
          Latitude: null,
          PricePicUrl: null,
          BigPrice01: 0.01,
          MidPrice01: 0.01,
          SmallPrice01: 0.01,
          SuperBigPrice01: 0.01,
          BigPrice: 0.01,
          MidPrice: 0.01,
          SmallPrice: 0.01,
          SuperBigPrice: 0.01,
          BigCappingPrice: 0.01,
          MidCappingPrice: 0.01,
          SmallCappingPrice: 0.01,
          SuperBigCappingPrice: 0.01,
          ChargingMode: 'Duration',
          DurationType: 'two',
          IsDeposit: 'N',
          IsAutoClear: 'N',
          Hour: 0,
          IsFree: 0,
          IntervalDay: 0,
          AutoClearType: 0,
          AutoClearTime: 0,
          SmallStagePriceJson: [],
          MidStagePriceJson: [],
          BigStagePriceJson: [],
          SuperBigStagePriceJson: [],
          // StagePriceJson: [],
          OpeningTime: null,
          AllowMidWayOpen: 0,
          UserId: null,
          UserId1: null,
          UserId2: null,
          UserId3: null,
          UserId4: null,
          DefendId: 0,
          DefendId1: 0,
          DefendId2: 0,
          DefendId3: 0,
          DefendId4: 0,
          MaId: undefined,
          ReturnConinProbability: 100
        }
      }
      this.showAdd = true
    },
    editField(detail) {
      this.detail = {
        ...detail,
        FieldInfo: {
          ...detail.FieldInfo,
          SmallStagePriceJson: detail.FieldInfo.SmallStagePriceJson || [],
          MidStagePriceJson: detail.FieldInfo.MidStagePriceJson || [],
          BigStagePriceJson: detail.FieldInfo.BigStagePriceJson || [],
          SuperBigStagePriceJson: detail.FieldInfo.SuperBigStagePriceJson || []
        }
      }
      console.log(this.detail)
      // if (detail.FieldInfo.StagePriceJson) {
      //   this.detail = detail
      // } else {
      //   detail.FieldInfo.StagePriceJson = []
      //   this.detail = detail
      // }
      this.status = false
      this.showAdd = true
    },
    member(detail) {
      this.id = detail.FieldInfo.FieldId
      // console.log(this.id)
      this.showMember = true
    },
    staff(detail) {
      this.id = detail.FieldInfo.FieldId
      // console.log(this.id)
      this.showStaff = true
    },
    // 添加员工
    handleBind(row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        if (!this.qr) {
          this.qr = new QrCode('qrcode', {
            text: process.env.BASE_API + '/binding/WithDraw.html?Field=' + row.FieldInfo.FieldId,
            // text: 'http://192.168.0.195:9527' + '/asd/WithDraw.html?FieldId=' + row.FieldInfo.FieldId,
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QrCode.CorrectLevel.H
          })
        } else {
          this.qr.makeCode(process.env.BASE_API + '/binding/WithDraw.html?Field=' + row.FieldInfo.FieldId)
        }
      })
    },
    handleClose(done) {
      done()
    },
    backList() {
      this.showAdd = false
      this.showStaff = false
      this.qryField()
    },
    back() {
      this.showMember = false
      this.showStaff = false
      this.showDetail = false
    }
  }
}
</script>
<style scoped>
#qrcode img{
  margin: auto;
  text-align: center;
}
.el-dialog__body{
  padding: 0 20px;
}
</style>
